import { Edge, Node } from 'reactflow'

import {
  Edge as DBLEdge,
  Node as DBLNode,
  EdgeType,
  NodeStep,
  NodeStepInput,
  NodeType,
} from '@ui/__generated__/graphql'
import dayjs from 'dayjs'

export const formatRFNode = (node: Node, pipelineId: string, userId?: string): DBLNode => {
  return {
    id: node.id,
    type: node.type as NodeType,
    data: {
      pipelineId: node.data.pipelineId || pipelineId,
      description: node.data.description,
      code: node.data.code || '',
      exportType: node.data.exportType || '',
      status: {
        logsEnabled: node.data.status.logsEnabled ?? false,
        spansEnabled: node.data.status.spansEnabled ?? false,
        metricsEnabled: node.data.status.metricsEnabled ?? false,
        logsStatus: node.data.status.logsStatus || '',
        spansStatus: node.data.status.spansStatus || '',
        metricsStatus: node.data.status.metricsStatus || '',
      },
      steps: node.data.steps || [],
      createdTimestamp: node.data.createdTimestamp || dayjs().toISOString(),
      updatedTimestamp: node.data.updatedTimestamp || dayjs().toISOString(),
      createdBy: node.data.createdBy || userId || 'SYS',
      updatedBy: node.data.updatedBy || userId || 'SYS',
      destinationId: node.data.destinationId || null,
    },
  }
}

export const formatRFEdges = (edges: Edge, pipelineId: string, userId?: string): DBLEdge => {
  return {
    id: edges.id,
    type: edges.type as EdgeType,
    source: edges.source,
    sourceHandle: edges.sourceHandle,
    target: edges.target,
    targetHandle: edges.targetHandle,
    data: {
      pipelineId: edges.data.pipelineId || pipelineId,
      createdTimestamp: edges.data.createdTimestamp || dayjs().toISOString(),
      lastUpdatedTimestamp: edges.data.lastUpdatedTimestamp || dayjs().toISOString(),
      createdBy: edges.data.createdBy || userId || 'SYS',
      lastUpdatedBy: edges.data.lastUpdatedBy || userId || 'SYS',
    },
  }
}

export const formatSteps = (steps: NodeStep[]): NodeStepInput[] => {
  return steps.map((step) => {
    return {
      id: step.id,
      config: step.config || {},
      predicate: step.predicate || {},
      stepTypeId: step.stepType.id,
      nodeId: step.nodeId,
      order: step.order,
      logsEnabled: step.logsEnabled,
      metricsEnabled: step.metricsEnabled,
      spansEnabled: step.spansEnabled,
    }
  }) as NodeStepInput[]
}
